module.exports = __webpack_public_path__ + "static/media/main-slide-2.93194a3f.jpg";